import * as React from "react";
import { observer } from "mobx-react-lite";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderAWSNodePoolAddRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (isDone) {
      navigate(
        `${pathname.replace("-add", "")}${
          mk8sDraft.provider_aws.nodePools[mk8sDraft.provider_aws.nodePools.length - 1].index
        }`
      );
      return;
    }

    mk8sDraft.provider_aws.addNodePool();
    setIsDone(true);
  }, [isDone]);

  return null;
};

export const ProviderAWSNodePoolAdd = observer(ProviderAWSNodePoolAddRaw);
